import PropTypes from "prop-types";
import { HiCheckCircle } from "react-icons/hi2";
import CustomModal from "../../../ui/CustomModal/CustomModal";
import CustomButton from "../../../ui/CustomButton/CustomButton";

export default function ManualEntrySuccessModal({
  opened,
  batchId,
  onAddAnother,
  onViewHistory,
}) {
  return (
    <CustomModal
      opened={opened}
      onClose={() => {}}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      centered
      radius="lg"
      size="md"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      styles={{ body: { padding: "32px 24px" } }}
    >
      <div className="flex flex-col items-center text-center">
        {/* Ripple icon */}
        <div className="relative w-24 h-24 flex items-center justify-center mx-auto mb-6">
          <div className="absolute w-24 h-24 rounded-full bg-green-100 opacity-50" />
          <div className="absolute w-16 h-16 rounded-full bg-green-200 opacity-70" />
          <div className="relative w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
            <HiCheckCircle className="text-white" size={22} />
          </div>
        </div>

        <p className="text-lg font-bold text-gray-900">
          Batch Submitted Successfully!
        </p>

        {/* "Pending approval" is inaccurate for both callers of this modal: manual
            entry auto-approves inline server-side, and file-upload's approval
            has already completed by the time this shows. Left as-is per product. */}
        <p className="text-sm text-gray-500 mt-2 leading-relaxed">
          Your manual batch payment has been submitted and is pending approval.
        </p>

        {batchId && (
          <div className="flex items-center gap-2 mt-4">
            <span className="text-sm text-gray-500">Batch:</span>
            <span className="text-sm font-semibold text-primary-600">
              #{batchId}
            </span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 xs:grid-cols-2 gap-2 mt-8">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          onClick={onAddAnother}
        >
          Add Another Batch
        </CustomButton>
        <CustomButton
          fullWidth
          variant="outline"
          color="gray"
          radius="md"
          onClick={onViewHistory}
        >
          View Upload History
        </CustomButton>
      </div>
    </CustomModal>
  );
}

ManualEntrySuccessModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  batchId: PropTypes.string,
  onAddAnother: PropTypes.func.isRequired,
  onViewHistory: PropTypes.func.isRequired,
};
